const _sm = "0 1px 1px rgb(0 0 0 / 0.05)"
const _DEFAULT = ["0 1px 2px rgb(0 0 0 / 0.1)","0 1px 1px rgb(0 0 0 / 0.06)"]
const _md = ["0 4px 3px rgb(0 0 0 / 0.07)","0 2px 2px rgb(0 0 0 / 0.06)"]
const _lg = ["0 10px 8px rgb(0 0 0 / 0.04)","0 4px 3px rgb(0 0 0 / 0.1)"]
const _xl = ["0 20px 13px rgb(0 0 0 / 0.03)","0 8px 5px rgb(0 0 0 / 0.08)"]
const _2xl = "0 25px 25px rgb(0 0 0 / 0.15)"
const _none = "0 0 #0000"
const _product = "0px 0px 10px rgba(0, 0, 0, 0.08)"
const _step = "0px 4px 6px rgba(0, 0, 0, 0.08)"
const config = { "sm": _sm, "DEFAULT": _DEFAULT, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl, "none": _none, "product": _product, "step": _step,  }
export { config as default, _sm, _DEFAULT, _md, _lg, _xl, _2xl, _none, _product, _step }